function postAjax(url, data, success) {
    var params = typeof data == 'string' ? data : Object.keys(data).map(
            function(k){ return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) }
        ).join('&');
  
    var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open('POST', url);
    xhr.onreadystatechange = function() {
        if (xhr.readyState>3 && xhr.status==200) { 
            success(xhr.responseText); 
        }  else if (xhr.status !== 200) {
            console.log('Request failed.  Returned status of ' + xhr.status + ' and a ready state of ' + xhr.readyState);
        }
    };
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.send(params);
    return xhr;
}

var serialize = function (form) {
	var arr = [];
	Array.prototype.slice.call(form.elements).forEach(function (field) {
		if (!field.name || field.disabled || ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1) return;
		if (field.type === 'select-multiple') {
			Array.prototype.slice.call(field.options).forEach(function (option) {
				if (!option.selected) return;
				arr.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(option.value));
			});
			return;
		}
		if (['checkbox', 'radio'].indexOf(field.type) >-1 && !field.checked) return;
		arr.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value));
	});
	return arr.join('&');
};

function validateContactForms (type) {

    var passed = true;
    var validateFields = ['email','name','lname'];

    if (document.querySelector('#'+type+'-contact #callBack').checked || type=='detailed') {
        document.querySelector('#'+type+'-contact #number').required=true;
        validateFields.push('number');
    }

    document.querySelector('.modal-new .error').style.display="none";

    for (var i=0; i<validateFields.length; i++) {
        if (document.querySelector('#'+type+'-contact #'+validateFields[i]).value=='') {
            document.querySelector('#'+type+'-contact #'+validateFields[i]+'-error').style.display="block";
            passed = false;
        }
    }

    return passed;
}

function contactus() {

    document.querySelectorAll(".tabhead").forEach(function(contacttab){
        contacttab.onclick = function(selectedtab) {
            document.querySelectorAll(".tab-content, .tabhead").forEach(function(tab){
                tab.classList.remove("active");
                // tab.classList.toggle("active");
            });
            
            var num = selectedtab.srcElement.getAttribute("data-id");
            document.querySelector('#tabs-'+num).classList.add('active');
            document.querySelector('#tabhead-'+num).classList.add('active');
        }
    });


    document.querySelectorAll("button[type=submit]").forEach(function(sumbitbtn){
        sumbitbtn.onclick = function(selectedbtn) {
            var type = selectedbtn.srcElement.getAttribute("data-id");

            var validate = validateContactForms(type);

            if (validate) {
                
                var formData = serialize(document.querySelector('#'+type+'-contact'));
                postAjax(SITE_URL+'ajax/responsive/send-contact.php', formData, function(data){document.querySelector('#'+type+'-contact').innerHTML=data});
            }
            
        }
    });
}

export default contactus;